import { render, staticRenderFns } from "./ProcesarSolicitud.vue?vue&type=template&id=720fddde"
import script from "./ProcesarSolicitud.vue?vue&type=script&lang=js"
export * from "./ProcesarSolicitud.vue?vue&type=script&lang=js"
import style0 from "./ProcesarSolicitud.vue?vue&type=style&index=0&id=720fddde&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports